import OrderHandler from "../OrderHandler";
import Mediator from "../../../Utilities/Mediator";
import DatePicker from "../../../DomUtilities/DatePicker";
import { DateTime } from 'luxon';

export default class DeliveryDatePicker {
	private dateInput: HTMLInputElement;
	private dateError: HTMLParagraphElement;
	private datePicker: DatePicker;
	private readonly INPUT_BORDER_COLOR: string = "#d80027";
	private readonly Error_BORDER_COLOR: string = "#bdbdbd";

	constructor() {
		this.dateInput = document.querySelector('#date');
		if (!this.dateInput) {
			OrderHandler.order.deliveryDate = DateTime.now().toJSDate();
			Mediator.emit("orderStateChanged");
		} else {
			this.init();
		}
	}

	private init() {
		this.dateError = document.querySelector('#date + img + p');
		this.datePicker = new DatePicker("#date", this.dateInput.dataset.lang);

		this.datePicker.setProperty("disable",
			[
				date => date.getDay() === 0 || date.getDay() === 6
			]);
		this.datePicker.setProperty("minDate", new Date());
		this.datePicker.setProperty("closeOnSelect", true);

		this.validateDate();
		this.addOnChangeListener();
	}

	private validateDate() {
		if (this.datePicker.isValid) {
			this.dateError.style.opacity = "0";
			this.dateError.style.marginBottom = "0px";
			this.dateInput.style.borderColor = this.Error_BORDER_COLOR;
			OrderHandler.order.deliveryDate = this.datePicker.DateValue;
		} else {
			this.dateError.style.opacity = "1";
			this.dateError.style.marginBottom = "15px";
			this.dateInput.style.borderColor = this.INPUT_BORDER_COLOR;
			OrderHandler.order.deliveryDate = null;
		}
		Mediator.emit("orderStateChanged");
	}

	private addOnChangeListener() {
		this.dateInput.onchange = () => {
			this.validateDate();
		}
	}
}
